/**
 * React ErrorBoundary（開発モード専用）
 * コンポーネントのレンダリングエラーをsinVに報告する
 */

import React from 'react';

const SINV_DEBUG_API = (import.meta as any).env?.VITE_SINV_DEBUG_API || 'http://localhost:8000/api/__debug/error';

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class DebugErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    fetch(SINV_DEBUG_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        type: 'react',
        message: error.message,
        stack: error.stack,
        componentStack: errorInfo.componentStack,
        timestamp: new Date().toISOString(),
      }),
    }).catch(() => {});
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '20px', background: '#fee', border: '1px solid #f00', borderRadius: '8px', margin: '20px' }}>
          <h2 style={{ color: '#c00' }}>表示エラーが発生しました</h2>
          <pre style={{ fontSize: '12px', overflow: 'auto' }}>{this.state.error?.message}</pre>
          <button onClick={() => this.setState({ hasError: false, error: null })}>再試行</button>
        </div>
      );
    }
    return this.props.children;
  }
}
